// src/Components/SystemMultiSelect/SystemMultiSelect.js
import React from 'react';
import Select from 'react-select';

// Our three HVAC system options
const hvacOptions = [
  { value: 'fancoil', label: 'Fancoil' },
  { value: 'heatpump', label: 'Heatpump' },
  { value: 'erv', label: 'ERV' },
];

// Same custom styles you use for the IssueMultiSelect
const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: 'none',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    minHeight: '48px',
    ':hover': { border: 'none' },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 8px',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#eef6ff',
    borderRadius: '4px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#1f5eec',
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#1f5eec',
    ':hover': {
      backgroundColor: '#cce0ff',
      color: '#1f5eec',
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#999',
    ':hover': {
      color: '#666',
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: '#999',
    ':hover': {
      color: '#666',
    },
  }),
};

function SystemMultiSelect({ selectedSystems, setSelectedSystems, placeholder }) {
  // Convert our string array (e.g. ['fancoil', 'erv']) to react-select options
  const selectedOptions = selectedSystems.map((val) => ({
    value: val,
    label: val.charAt(0).toUpperCase() + val.slice(1), // e.g. "fancoil" -> "Fancoil"
  }));

  // Handler for react-select
  const handleChange = (selected) => {
    if (!selected) {
      setSelectedSystems([]);
      return;
    }
    // Convert react-select options back to strings
    setSelectedSystems(selected.map((opt) => opt.value));
  };

  return (
    <Select
      isMulti
      options={hvacOptions}
      value={selectedOptions}
      onChange={handleChange}
      placeholder={placeholder || 'Select HVAC System...'}
      styles={customStyles}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
    />
  );
}

export default SystemMultiSelect;
